export default __webpack_public_path__ + "static/media/125-windstorm.52585648.jpeg";